<template>
    <div>
        <v-toolbar color="primary" dark>
                <h2 :style="$store.state.textFormatting.headers"> Glossary of terms - click to expand </h2>
        </v-toolbar>
        <v-card>
            <v-container grid-list-xl>
                <v-layout wrap>
                    
                    <v-flex xs12 md6>
                        <v-expansion-panel>
                            <v-expansion-panel-content>
                                <template v-slot:header>
                                    <h2 :style="$store.state.textFormatting.headers"> Event </h2>
                                </template>
                                <v-card max-height="400" class="scroll">
                                    <v-card-text :style="$store.state.textFormatting.main">
                                    <h4>
                                        <span class="font-weight-medium"> Events are peer specific messages, this is one peers view of the change in the network that has occured.
                                        Duplicate messages in each 5 minute window add to the event count, therefore only unique events for a specific peer are kept.
                                        Some information regarding the type of message we think it is, based on analytics (hijack scope, path change, withdrawal,
                                        ownership assertion or first time seeing the prefix) is added and stored alongside the event.
                                        There are various attributes to each event, explained below: </span>

                                        <v-layout wrap>
                                            <v-flex xs12>
                                                <ul>
                                                    <li> Peer ASN: <span class="font-weight-medium"> The ASN broadcasting the initial BGP message i.e. the first ASN in the AS path </span></li>
                                                    <li> New ASN path: <span class="font-weight-medium"> The ASNs a packet of information will 'jump' through to get frotext the current origin ASN to the peer ASN </span></li>
                                                    <li> Old ASN path: <span class="font-weight-medium"> As above but prior to the event occurance </span></li>
                                                    <li> Event Count: <span class="font-weight-medium"> How many events with the above attributes have occured in the last 5 minute window </span></li>
                                                    <li> Hijack Score: <span class="font-weight-medium"> The likelihood in the eyes of the analyst that this event corresponds to a BGP hijack </span></li>
                                                    <li> Impact Score: <span class="font-weight-medium"> Should this event turn out to be a hijack, the scale of the potential impact it would cause to the victitext AS </span></li>
                                                </ul>
                                            </v-flex>
                                        </v-layout>

                                    </h4>
                                    </v-card-text>
                                    </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-flex>

                    <v-flex xs12 md6>
                        <v-expansion-panel>
                            <v-expansion-panel-content>
                                <template v-slot:header>
                                    <h2 :style="$store.state.textFormatting.headers"> Event/Alert Type </h2>
                                </template>
                                <v-card max-height="400" class="scroll">
                                    <v-card-text :style="$store.state.textFormatting.main">
                                    <h4>
                                        <span class="font-weight-medium"> Events and Alerts are categorized into 5 main types. All events are from the viewpoint of a single BGP peer </span>

                                        <v-layout wrap>
                                            <v-flex xs12>
                                                
                                                <ul>
                                                    <li> Ownership Assertion: <span class="font-weight-medium"> A prefix previously announced by one AS is announced by a different AS. </span></li>
                                                    <li> Sub-ownership Assertion: <span class="font-weight-medium"> A new prefix is announced which is a subset of a prefix previously announced by a different AS. </span></li>
                                                    <li> Super-ownership Assertion: <span class="font-weight-medium"> A new prefix is announced which is a superset of a prefix previously announced by a different AS. </span></li>
                                                    <li> First-Seen: <span class="font-weight-medium"> A new prefix is announced which has never been seen before (may coincide with a sub/super-owernreship assertion). </span></li>
                                                    <li> New AS in Path: <span class="font-weight-medium"> A path to a prefix is announced which contains an AS never-before seen in paths to that prefix. </span></li>
                                                </ul>
                                                <br />                                                                           
                                            </v-flex>
                                        </v-layout>
                                    </h4>
                                    </v-card-text>
                                    </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-flex>

                    <v-flex xs12 md6>
                        <v-expansion-panel>
                            <v-expansion-panel-content>
                                <template v-slot:header>
                                    <h2 :style="$store.state.textFormatting.headers"> Episode </h2>
                                </template>
                                <v-card max-height="400" class="scroll">
                                    <v-card-text :style="$store.state.textFormatting.main">
                                    <h4>
                                        <span class="font-weight-medium"> Where events show the change in a network from the
                                         perspective of an individual, episodes aggregate events based on the
                                          key attributes: </span>

                                        <v-layout wrap>
                                            <v-flex xs12 md3>
                                                <ul>
                                                    <li> 5 min time window </li>    
                                                </ul>
                                            </v-flex>
                                            <v-flex xs36 md3>
                                                <ul>
                                                    <li> Prefix </li>    
                                                </ul>
                                            </v-flex>
                                            <v-flex xs36 md3>
                                                <ul>
                                                    <li> Origin ASN [New] </li>    
                                                </ul>
                                            </v-flex>
                                            <v-flex xs36 md3>
                                                <ul>
                                                    <li> Origin ASN [Old] </li>    
                                                </ul>
                                            </v-flex>
                                        </v-layout>

                                        <span class="font-weight-medium"> <p> This allows the user a view of all the messages from 
                                        a specific change in the network to be seen. Episodes can then be used to run
                                        analytics on a group of events thus giving a more rounded view of the change. </p>
                                        
                                        <p>
                                        The downside of using episodes for analysis is that you may miss some granularity in the data, hence
                                        we provide various views of what events constitute a given episode. You can either view the exact events
                                        that constitute the episode, or view the ASN stats/ episode stats.
                                        </p> </span>
                                    </h4>
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-flex>

                    <v-flex xs12 md6>
                        <v-expansion-panel>
                            <v-expansion-panel-content>
                                <template v-slot:header>
                                    <h2 :style="$store.state.textFormatting.headers"> Event Metadata </h2>
                                </template>
                                <v-card max-height="400" class="scroll">
                                    <v-card-text :style="$store.state.textFormatting.main">
                                    <h4>
                                        <span class="font-weight-medium"> There are many additional fields which contribute to the scoring 
                                        for events, which may not be immediately visible: </span>

                                        <v-layout wrap>
                                            <v-flex xs12>
                                                
                                                <ul>
                                                    <li> Hijack Scope: <span class="font-weight-medium"> The difference in CIDR from the anomalous prefix (i.e. from the event) to the owner prefix. </span></li>
                                                    <li> Hijack Subtype: <span class="font-weight-medium"> <span class="font-italic"> Observed: </span> The ASN has been seen to own the given prefix before, but is not the authorative owner. <span class="font-italic"> Full: </span> The ASN has not been seen as an owner of this prefix before and is not the authorative owner</span></li>
                                                    <li> Edit Distance: <span class="font-weight-medium"> The amount of swaps/ additions/ removals needed to get from the old AS path to the new AS path. Accounts for duplicate adjacent entries of ASNs. </span></li>
                                                    <li> Path Change Type: <span class="font-weight-medium"> Detects the type of path change, corresponds to the amount of ASNs that have stayed the same, starting from the origin ASN, for example:</span></li>
                                                    <ul>
                                                        <li> <span class="font-weight-medium"> 1 2 3 <span style="text-decoration:underline">4</span> -> 1 2 3 <span style="text-decoration:underline">5</span> </span> : Type 0 </li>
                                                        <li> <span class="font-weight-medium"> 5 6 <span style="text-decoration:underline">7</span> 8 -> 5 6 <span style="text-decoration:underline">9</span> 8 </span> : Type 1 </li>
                                                    </ul>
                                                    <li> ASN Geo Comparison: <span class="font-weight-medium"> The geographical correlation between the old and new origin ASNs. </span></li>
                                                    <li> Prefix ASN Geo Comparison: <span class="font-weight-medium"> The geographical correlation between the anomalous prefix and the new origin ASN. </span></li>
                                                    <li> Restricted DNS: <span class="font-weight-medium"> If the prefix falls under the list of restricted DNS prefixes </span></li>
                                                    <li> Controlled Prefix: <span class="font-weight-medium"> If the prefix falls under the list of prefixes defined by the user (affects only the sub hijack/ impact scores) </span></li>
                                                    <li> Bogon: <span class="font-weight-medium"> There are some prefixes that should never be seen in BGP messages, called bogons. </span></li>
                                                    <li> Route Leak Flag: <span class="font-weight-medium"> There are certain events which correspond to route leaks, where ownership of a prefix may 'slip' to the ASN one up the chain from the origin, for example: </span></li>
                                                    <ul>
                                                        <li> <span class="font-weight-medium"> 1 2 3 <span style="text-decoration:underline">4</span> -> 1 2 3 </span>: Type 1 (type 0 path change)</li>
                                                        <!-- <li> <span class="font-weight-medium"> 5 6 7 <span style="text-decoration:underline">8</span> -> 5 6 7 <span style="text-decoration:underline">9</span></span> : Type 2 (also a type 0 path change) </li> !-->
                                                    </ul>
                                                    
                                                    <li> Registrar Flag: <span class="font-weight-medium"> Is the new origin ASN allowed to advertise the anomalous prefix, in the eyes of the domain registrars across the world </span></li>
                                                </ul>
                                                <br />
                                                <v-card>
                                                    <li> References: </li>
                                                    <ul>
                                                        <li> <a href="https://www.caida.org/publications/papers/2018/artemis/artemis.pdf"> ARTEMIS: Neutralizing BGP Hijacking within a Minute </a> - <span class="font-weight-medium"> Pavlos Sermpezis et. al. </span></li>
                                                        <li> <a href="https://www.researchgate.net/publication/309519246_BGP_Anomaly_Detection_Techniques_A_Survey"> BGP Anomaly Detection Techniques: A Survey </a> - <span class="font-weight-medium"> Bahaa Al-Musawi et. al. </span></li>
                                                        <li> <a href="http://pages.cs.wisc.edu/~pb/vizsec16_final.pdf"> Bigfoot: A Geo-based Visualization Methodology for Detecting BGP Threat </a> - <span class="font-weight-medium"> Meenakshi Syamkumar et. al. </span></li>
                                                    </ul>
                                                </v-card>
                                                
                                                
                                            </v-flex>
                                        </v-layout>

                                    </h4>
                                    </v-card-text>
                                    </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-flex>

                    <v-flex xs12 md6>
                        <v-expansion-panel>
                            <v-expansion-panel-content>
                                <template v-slot:header>
                                    <h2 :style="$store.state.textFormatting.headers"> Alert </h2>
                                </template>
                                <v-card max-height="400">
                                    <v-card-text :style="$store.state.textFormatting.main">
                                    
                                    <h4>
                                        <li class="font-weight-medium"> The user will specify the hijack & impact scores for specific ASNs at which events will begin to
                                        aggregate into alerts. For example, if I specify H = 20, I = 20 for ASN 200, any events involving
                                        ASN 200 in the 'new ASN path' with both scores above 20 will add to that alert's event count. </li>
                                         
                                    </h4>
                                    </v-card-text>
                                    </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-flex>

                    <v-flex xs12 md6>
                        <v-expansion-panel>
                            <v-expansion-panel-content>
                                <template v-slot:header>
                                    <h2 :style="$store.state.textFormatting.headers"> Notification </h2>
                                </template>
                                <v-card max-height="400">
                                    <v-card-text :style="$store.state.textFormatting.main">
                                    
                                    <h4>
                                    
                                        <li class="font-weight-medium"> When the event count for an alert begins (i.e. >0), an initial email
                                        is sent out to the user. </li> <li class="font-weight-medium">                                        
                                        The user also specifies a validation score for each ASN. When 
                                        the event count for the alert passes the threshold, an additional email is sent out to the user,
                                        and an additional one for each time the threshold is breached again.
                                        </li>
                                    </h4>
                                    </v-card-text>
                                    </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-flex>
                    
                </v-layout>
            </v-container>
        </v-card>
    </div>
</template>
<script>
export default {
    name: 'glossaryofterms'
    
}
</script>

<style>

.scroll {
    overflow-y: scroll;
}
</style>
